import React from "react";
import { colors, shadows } from "../../../styles/variables.js";
import Section from "../../../styles/Section.js";
import { H3 } from "../../../styles/Headings.js";
import { P2 } from "../../../styles/Paragraphs.js";
import { Highlight } from "../../../styles/Utilities.js";
import { SkillsContainer, Skill, SkillTitle } from "./SkillsSectionStyles.js";
import Image from "../../../components/Image.js";
import InView from "react-intersection-observer";

const skillsContainerVariant = {
   hidden: {
      opacity: 0,
      transition: {
         when: "afterChildren",
         opacity: {
            duration: 0.2
         }
      }
   },
   visible: {
      opacity: 1,
      transition: {
         when: "beforeChildren",
         staggerChildren: 0.1,
         opacity: {
            duration: 0.2
         }
      }
   }
};

const skillCardVariant = {
   hidden: {
      y: 50,
      opacity: 0,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.3
         },
         opacity: {
            duration: 0.2
         }
      }
   },
   visible: {
      y: 0,
      opacity: 1,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.3
         },
         opacity: { duration: 0.2 }
      }
   }
};

function SkillsSectionContainer() {
   return (
      <Section id="skills">
         <H3 center>
            <Highlight>Technologies</Highlight> I Work With
         </H3>
         <P2
            center
            style={{ width: "49rem", maxWidth: "100%", margin: "1.2rem auto" }}
         >
            I work with both frontend and backend technologies. Working on both
            sides help me plan and develop projects from a broader point of view
            that gives me a better understanding of overall requirements of the
            project.
         </P2>
         <InView threshold={0.25}>
            {({ ref, inView }) => (
               <SkillsContainer
                  ref={ref}
                  initial="hidden"
                  animate={inView ? "visible" : ""}
                  variants={skillsContainerVariant}
               >
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.javascriptDark }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/javascript-icon.svg"
                        alt="javascript"
                     />
                     <SkillTitle>Javascript</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.node }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/node-js-icon.svg"
                        alt="node.js"
                     />
                     <SkillTitle>Node.js</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.reactDark }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/react-icon.svg"
                        alt="react"
                     />
                     <SkillTitle>React</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.redux }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/redux-icon.svg"
                        alt="redux"
                     />
                     <SkillTitle>Redux</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.mongodbDark }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/mongodb-icon.svg"
                        alt="mongodb"
                     />
                     <SkillTitle>MongoDB</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.gatsbyDark }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/gatsbyjs-icon.svg"
                        alt="gatsby"
                     />
                     <SkillTitle>Gatsby</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.postgresqlDark }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/mysql-icon.svg"
                        alt="mysql"
                     />
                     <SkillTitle>MySQL</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.restapiDark }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/restapi-icon.svg"
                        alt="rest-api"
                     />
                     <SkillTitle>REST API</SkillTitle>
                  </Skill>
                  <Skill
                     variants={skillCardVariant}
                     style={{ borderColor: colors.github }}
                  >
                     <Image
                        className="skill-icon"
                        src="icons/github-icon.svg"
                        alt="github"
                     />
                     <SkillTitle>Git & Github</SkillTitle>
                  </Skill>
               </SkillsContainer>
            )}
         </InView>
      </Section>
   );
}

export default SkillsSectionContainer;
